<template>
  <div
    class="badge"
    :class="`badge--${props.type}`"
  >
    <span v-html="sanitize(props.text)" />
  </div>
</template>

<script setup>
const props = defineProps(buildProps({
  text: {
    type: String,
    required: true,
  },
  type: {
    type: String,
    values: ['neutral', 'info', 'success', 'warning', 'critical'],
    default: 'neutral',
  },
}));
</script>

<style scoped>
.badge {
  @apply pl-2.5 pr-2 py-0.5 min-h-[1.25rem] inline-flex items-center justify-center rounded-full;
  @apply font-medium text-xs;
  @apply bg-gray-100 text-gray-900;

  &::before {
    @apply h-2 w-2 rounded-full mr-1.5 flex-shrink-0;
    @apply bg-gray-500;
    content: '';
  }

  &--info {
    @apply bg-blue-100 text-blue-900 before:bg-blue-500;
  }

  &--success {
    @apply bg-green-100 text-green-900 before:bg-green-500;
  }

  &--warning {
    @apply bg-yellow-100 text-yellow-900 before:bg-yellow-500;
  }

  &--critical {
    @apply bg-red-100 text-red-900 before:bg-red-500;
  }
}
</style>
